import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "../site/Motion";

const Tile = ({ to, src, label, title, className, testid, frame = "" }) => (
  <Reveal className={className}>
    <Link to={to} data-testid={testid} className={`group relative block h-full min-h-[340px] overflow-hidden ${frame}`}>
      <img src={src} alt={title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105" />
      <div className="absolute inset-0 spotlight" />
      <div className="absolute inset-x-0 bottom-0 p-6 sm:p-8 flex items-end justify-between gap-4 text-cream">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-cream/85">{label}</p>
          <h3 className="mt-2 font-serif text-3xl sm:text-5xl leading-none">{title}</h3>
        </div>
        <span className="shrink-0 w-12 h-12 rounded-full border border-cream/60 flex items-center justify-center group-hover:bg-cream group-hover:text-cypress transition-colors duration-300"><ArrowUpRight className="w-5 h-5" /></span>
      </div>
    </Link>
  </Reveal>
);

export const TwoSouls = () => (
  <section data-testid="two-souls-section" className="bg-cream">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 py-24 sm:py-32">
      <div className="grid lg:grid-cols-12 gap-8 mb-14">
        <Reveal className="lg:col-span-4"><Eyebrow>Due anime, un linguaggio</Eyebrow></Reveal>
        <Reveal delay={0.1} className="lg:col-span-8">
          <p className="font-serif text-3xl sm:text-5xl leading-[1.1] text-ink">
            In negozio nascono ogni giorno bouquet e composizioni. Nei matrimoni i fiori diventano <em className="text-terra">architettura</em>, luce, ricordo.
          </p>
        </Reveal>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-12 md:grid-rows-2 gap-4 sm:gap-5 md:h-[760px]">
        <Tile to="/negozio" testid="bento-shop" src="/img/s1.jpg" label="Il negozio" title="Creazioni di ogni giorno" className="md:col-span-7 md:row-span-2" frame="rounded-tr-[160px]" />
        <Tile to="/portfolio" testid="bento-wedding" src="/img/w1.jpg" label="Wedding florist" title="Portfolio matrimoni" className="md:col-span-5" frame="rounded-tl-[120px]" />
        <Reveal delay={0.15} className="md:col-span-5">
          <div className="h-full min-h-[300px] bg-cypress text-cream p-7 sm:p-10 flex flex-col justify-between relative overflow-hidden">
            <img src="/img/olive2.jpg" alt="" aria-hidden className="absolute -right-10 -bottom-10 w-2/3 opacity-20 mix-blend-luminosity" />
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-brass-light relative">Consulenza wedding</p>
            <div className="relative">
              <p className="font-serif text-3xl sm:text-4xl leading-tight">Raccontatemi il vostro giorno: il progetto floreale parte da voi.</p>
              <Link to="/contatti#consulenza" data-testid="bento-consulenza-cta" className="mt-6 inline-flex items-center gap-2 rounded-full bg-cream text-cypress px-5 py-2.5 text-sm hover:bg-terra hover:text-cream transition-colors">Richiedi una consulenza <ArrowUpRight className="w-4 h-4" /></Link>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
